import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";


class MaximizeViewerForm extends FormBase {
    public getMaximizeOverlay(target: Element): HTMLElement | null {
        return this.closest(target, `[data-role="${Roles.MAXIMIZE_VIEWER_OVERLAY}"]`, HTMLElement);
    }

    public getSnsContainer(overlay: HTMLElement): HTMLElement | null {
        return this.closest(overlay, "[data-sns-url][data-sns-platform]", HTMLElement);
    }

    public getElementModalBody(target: Element): HTMLElement | null {
        return this.closest(target, `[data-role="${Roles.ELEMENT_MODAL_BODY}"]`, HTMLElement);
    }

    public getPostDetailModeless(target: Element): HTMLElement | null {
        return this.closest(target, ".post-detail--modeless", HTMLElement);
    }

    public getDirectMaximizeCard(target: Element): HTMLElement | null {
        return this.closest(target, `[data-modal-usage="DIRECT_MAXIMIZE"]`, HTMLElement);
    }

    public getSnsTile(target: Element): HTMLElement | null {
        return this.closest(target, `[data-role="${Roles.SNS_PREVIEW_TILE}"]`, HTMLElement);
    }

    public getSnsTileRemove(target: Element): HTMLElement | null {
        return this.closest(target, `[data-role="${Roles.SNS_TILE_REMOVE}"]`, HTMLElement);
    }

    public getImageItem(target: Element): HTMLElement | null {
        return this.closest(target, ".board-image-item", HTMLElement);
    }

    public getOgpPreviewCard(target: Element): HTMLElement | null {
        return this.closest(target, `[data-role="${Roles.OGP_PREVIEW_CARD}"]`, HTMLElement);
    }

    public getOgpPreviewCardImage(card: HTMLElement): HTMLImageElement | null {
        return this.queryElement(card, ".ogp-preview-card__image", HTMLImageElement);
    }

    public getImage(item: HTMLElement): HTMLImageElement | null {
        return this.queryElement(item, "img", HTMLImageElement);
    }

    // For board-media-image where <img> is a direct child of board-images-grid (no .board-image-item wrapper)
    public getBoardGridImage(target: Element): HTMLImageElement | null {
        if (!(target instanceof HTMLImageElement)) return null;
        return this.closest(target, `[data-role="${Roles.BOARD_IMAGES_GRID}"]`, HTMLElement) ? target : null;
    }

    public getVideoWrap(target: Element): HTMLElement | null {
        return this.closest(target, `[data-role="${Roles.BOARD_VIDEO_WRAP}"]`, HTMLElement);
    }

    public getVideoSource(videoWrap: HTMLElement): HTMLSourceElement | null {
        return this.queryElement(videoWrap, "source", HTMLSourceElement);
    }

    public getVideoThumb(videoWrap: HTMLElement): HTMLImageElement | null {
        return this.queryElement(videoWrap, `[data-role="${Roles.BOARD_VIDEO_PREVIEW}"][data-video-url]`, HTMLImageElement);
    }

    public getProductImageMaximize(target: Element): HTMLImageElement | null {
        return this.closest(target, `[data-role="${Roles.PRODUCT_IMAGE_MAXIMIZE}"]`, HTMLImageElement);
    }

    public getCloseBtn(modal: HTMLElement): HTMLElement | null {
        return this.queryElement(modal, `[data-role="${Roles.MAXIMIZE_VIEWER_CLOSE}"]`, HTMLElement);
    }

    public getBackdrop(modal: HTMLElement): HTMLElement | null {
        return this.queryElement(modal, `[data-role="${Roles.MAXIMIZE_VIEWER_BACKDROP}"]`, HTMLElement);
    }

    public getModalBody(modal: HTMLElement): HTMLElement | null {
        return this.queryElement(modal, ".maximize-viewer-modal__body", HTMLElement);
    }

    public getIframe(modal: HTMLElement): HTMLIFrameElement | null {
        return this.queryElement(modal, `[data-role="${Roles.MAXIMIZE_VIEWER_IFRAME}"]`, HTMLIFrameElement);
    }

    public getImg(modal: HTMLElement): HTMLImageElement | null {
        return this.queryElement(modal, `[data-role="${Roles.MAXIMIZE_VIEWER_IMAGE}"]`, HTMLImageElement);
    }

    public getVideo(modal: HTMLElement): HTMLVideoElement | null {
        return this.queryElement(modal, `[data-role="${Roles.MAXIMIZE_VIEWER_VIDEO}"]`, HTMLVideoElement);
    }
}

export const maximizeViewerForm = new MaximizeViewerForm();
